// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2504":"911c35a4","6559":"c0557e40","6625":"c0557e40","9443":"c0557e40","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};